export * from './point-compliant-card'
export type { PointCompliantCardProps } from './point-compliant-card.types'
